import { forwardRef, type InputHTMLAttributes, useState } from 'react';

export interface InputPasswordProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** エラー状態 */
  error?: boolean;
  /** 追加のクラス名 */
  className?: string;
  /** 表示切り替えボタンを表示するか */
  showToggle?: boolean;
}

/**
 * AIPデザインシステムのパスワード入力コンポーネント
 */
export const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
  ({ error, className = '', showToggle = true, disabled, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    return (
      <div className={`aip-input-password ${className}`.trim()}>
        <input
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          className="aip-floating-field__control aip-input-password__input"
          aria-invalid={error || undefined}
          disabled={disabled}
          {...props}
        />
        {showToggle && (
          <button
            type="button"
            className="aip-input-password__toggle"
            onClick={toggleVisibility}
            aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
            disabled={disabled}
          >
            <span className="material-symbols-outlined">
              {showPassword ? 'visibility_off' : 'visibility'}
            </span>
          </button>
        )}
      </div>
    );
  }
);

InputPassword.displayName = 'InputPassword';

export default InputPassword;

